import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {ImageOptimizerState, ImageOptimizerStats} from "../reducers/image-optimizer.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getImageOptimizerState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.imageOptimizer);

export const getImageOptimizerStats = (websiteId: number) => createSelector(getImageOptimizerState,
  (state: ImageOptimizerState): ImageOptimizerStats =>
    state.entities[websiteId] && state.entities[websiteId].stats ? state.entities[websiteId].stats : null
);
export const getImageOptimizerAutoOptimizeEnabled = (websiteId: number) => createSelector(getImageOptimizerState,
  (state: ImageOptimizerState): boolean => state.entities[websiteId] && state.entities[websiteId].autoOptimizeEnabled ? state.entities[websiteId].autoOptimizeEnabled : null
);

